import React from "react";
import { PieChart } from 'echarts/charts';

import { EchartsCore } from "../Echart/UseEcharts";
import { ECHARTS_COLORS } from '../../constants/echarts-colors.constants';

const DoughnutChart = (props) => {
  const { items } = props;

  const ReactEchart = EchartsCore([PieChart]);

  const data = items?.map((item) => ({
    value: item.percent,
    name: item.label,
  })) ?? [];

  const options = {
    color: ECHARTS_COLORS,
    tooltip: {
      trigger: 'item',
      formatter: function (params) {
        return `${params.marker} ${params.name}: &nbsp;&nbsp;&nbsp; <b>${params.value}%</b>`;
      },
    },
    series: [
      {
        type: 'pie',
        radius: ['50%', '90%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
        labelLine: {
          show: false
        },
        data,
      }
    ]
  };

  return (
    <div style={{ minWidth: "300px", minHeight: "300px" }}>
      {data.length !== 0 &&
        <ReactEchart
          lazyUpdate
          opt={{ renderer: 'svg' }}
          option={options}
          width="100%"
          height="100%"
          style={{ maxWidth: '480px', width: '100%' }}
        />
      }
    </div>
  )
}

export default DoughnutChart;